import React, { FC } from 'react';
import { formatTime } from '@aarhus-university/au-lib-react-components/src/lib/dates';
import { useUserContext } from '@aarhus-university/au-lib-react-components/src/lib/context';
import { useReadExamNotificationMutation } from '../../services/api';
import { useTranslationsContext } from '../../lib/translation';

type Props = {
  notification: IExamNotification,
}

const NotificationItemComponent: FC<Props> = ({
  notification,
}) => {
  const user = useUserContext();
  const translations = useTranslationsContext();
  const [readNotification] = useReadExamNotificationMutation();

  let className = 'sub-nav__notification';
  if (!notification.read) {
    className += ' sub-nav__notification--unread';
  }
  return (
    <li className={className}>
      <div className="sub-nav__notification__text">
        <span dangerouslySetInnerHTML={{ __html: notification.text }} />
        <br />
        <span className="text--small sub-nav__notification__timestamp">
          {`${formatTime(notification.registered, 'll')}`}
        </span>
      </div>
      {
        ((notification.important && !notification.read) && (
          <button
            type="button"
            className="button button--icon--hide-label button--small button--icon button--dimmed"
            data-icon=""
            onClick={() => readNotification({
              id: notification.id,
              auId: user?.auId || 0,
            })}
          >
            {translations.generics.sub_nav.notifications.mark_as_read}
          </button>
        ))
      }
    </li>
  );
};

NotificationItemComponent.displayName = 'NotificationItemComponent';
export default NotificationItemComponent;
